export const FIXED_LAYOUT = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile'
}
